var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.name!='produs'&&_vm.$route.name!='Newsletter'&&_vm.$route.name!='Produse')?_c('div',{staticClass:"app-home__sale",style:(_vm.background),on:{"click":function($event){return _vm.goLink()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }